import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import { MyFixtureSelector, setFixtureSummary, setGeneralNote } from './reducers/MyFixtureReducer';
import { MyFixtureSearchSelector } from './reducers/MyFixtureSearchReducer';
import MyFixtureApi, { GetMyFixtureSummaryParam } from './api/MyFixtureApi';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import Utility from '../../app/utility';
import BaseResponse from '../../app/BaseResponse';
import FixtureSummaryModel from './models/FixtureSummaryModel';

const MyFixtureSummary: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const myFixtureViewData = useSelector(MyFixtureSelector);
    const MyFixtureSearchData = useSelector(MyFixtureSearchSelector);

    useEffect(() => {
        dispatch(showLoading(true));

        MyFixtureApi.GetMyFixtureSummary({
            year: MyFixtureSearchData.query.year
        } as GetMyFixtureSummaryParam)
            .then((response: BaseResponse<FixtureSummaryModel>) => {
                if (response.success) {
                    dispatch(setFixtureSummary(response.data));
                } else {
                    Utility.Alert.Error(response.message);
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
            })
            .finally(() => {
                dispatch(showLoading(false));
            });
    }, [])

    return (
        <>
            <CustomAccordion
                title="Summary"
                className="fixture-search-area"
                defaultOpen={true}>
                <div>Total fixtures handling in <span className="support-sheet-red-text">{MyFixtureSearchData.query.year == 0 ? "All Years" : MyFixtureSearchData.query.year}</span></div>
                <Grid container>
                    <Grid item xs={3}>TC</Grid>
                    <Grid item xs={3}>{myFixtureViewData.summary.totalTC}</Grid>
                    <Grid item xs={3}>TCT</Grid>
                    <Grid item xs={3}>{myFixtureViewData.summary.totalTCT}</Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={3}>COA</Grid>
                    <Grid item xs={3}>{myFixtureViewData.summary.totalCOA}</Grid>
                    <Grid item xs={3}>Voy</Grid>
                    <Grid item xs={3}>{myFixtureViewData.summary.totalVoy}</Grid>
                </Grid>
                <div>
                    (<span className="support-sheet-red-text">{myFixtureViewData.summary.onGoing}</span> ongoing, <span className="support-sheet-red-text">{myFixtureViewData.summary.outStanding}</span> outstanding, <span className="support-sheet-red-text">{myFixtureViewData.summary.closedFile}</span> closed file)
                </div>
                <div>
                    Average point: {myFixtureViewData.summary.averagePoint.toFixed(2)}
                </div>
            </CustomAccordion>
        </>
    )
};

export default MyFixtureSummary;